import { render, staticRenderFns } from "./ArticleConfig.vue?vue&type=template&id=3d17ee02"
import script from "./ArticleConfig.vue?vue&type=script&lang=js"
export * from "./ArticleConfig.vue?vue&type=script&lang=js"
import style0 from "./ArticleConfig.vue?vue&type=style&index=0&id=3d17ee02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports